export const PageNotFound = () => {
  return <>The page you are looking doesn't exist.</>;
};
